import React from 'react';
import { Footer as S4XFooter } from '@spotify-internal/s4x-masthead';

import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';
import { MastheadVariants } from 'utils/vertical';
import { useMastheadData } from 'providers/MastheadProvider';
import { TurnkeyFooter } from 'components/Masthead/Footer';

export const Footer = () => {
  const mastheadData = useMastheadData();

  const {
    verticalConfig: { features },
  } = useServerSideConstants();

  if (features.configureMasthead?.footer === MastheadVariants.S4A) {
    return <S4XFooter />;
  }

  if (!mastheadData?.footer) return null;

  return <TurnkeyFooter data={mastheadData.footer} />;
};
